/**
 * @namespace computec.b2b.portal.auth
 */

export interface OidcConfig {
	issuer: string;
	clientId: string;
	redirectUri: string;
	scopes: string;
	/** Alias of the staff identity provider, or null when the environment has no staff sign-in. */
	staffIdpHint: string | null;
}

interface AuthConfigResponse {
	issuer?: string;
	clientId?: string;
	staffIdpHint?: string | null;
}

/**
 * Reads the OIDC settings from the API (GET /api/v1/auth/config), which derives them from the
 * configuration it validates tokens with - one source of the issuer for the API and the SPA.
 */
export async function loadOidcConfig(fetchFn: typeof fetch = window.fetch.bind(window)): Promise<OidcConfig> {
	const response = await fetchFn("/api/v1/auth/config", { headers: { Accept: "application/json" } });
	if (!response.ok) {
		throw new Error(`Auth configuration request failed: HTTP ${response.status}`);
	}
	const body = await response.json() as AuthConfigResponse;
	if (!body.issuer || !body.clientId) {
		throw new Error("Auth configuration is incomplete: issuer and clientId are required.");
	}
	return {
		issuer: body.issuer.replace(/\/+$/, ""),
		clientId: body.clientId,
		redirectUri: window.location.origin + window.location.pathname,
		scopes: "openid profile email",
		staffIdpHint: body.staffIdpHint ?? null
	};
}
